var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-3 mt-sm-5 pt-5"},[(_vm.enableReport)?_c('div',[_c('Portfolio',{attrs:{"imgPath":_vm.imgPath,"alphaScopeData":_vm.alphaScopeData,"transactionData":_vm.transactionData,"is_premium":_vm.is_premium}})],1):_c('div',[_c('ImportHoldings')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-91c61bdc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/importHoldings.vue
// module id = null
// module chunks = 